webpackJsonp([59],{

/***/ "Tzrl":
/***/ (function(module, exports, __webpack_require__) {

var SectionSignUp = (function () {
    function SectionSignUp() {
        this.bgTopColor = this.bgTopColor || 'gray';
        this.ltTitle = this.ltTitle || 'start-creating-now';
        this.buttons = this.buttons || true;
    }
    return SectionSignUp;
}());
angular.module('animatronApp.sectionSignUp', []).component('sectionSignUp', {
    bindings: {
        ltTitle: '<?',
        buttons: '<?',
        bgTopColor: '<?',
    },
    controller: SectionSignUp,
    templateUrl: __webpack_require__("tPqj")
});


/***/ }),

/***/ "tPqj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-sign-up_44683544190d425e4b5e0470d8d8e2e0.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/59-28dc41a6a889e793a2e2.min.js